import { render, staticRenderFns } from "./ModgroupItems.vue?vue&type=template&id=0f8120f0&scoped=true"
import script from "./ModgroupItems.vue?vue&type=script&lang=ts"
export * from "./ModgroupItems.vue?vue&type=script&lang=ts"
import style0 from "./ModgroupItems.vue?vue&type=style&index=0&id=0f8120f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8120f0",
  null
  
)

export default component.exports